import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';

@Pipe({
  name: 'pluck'
})
export class PluckPipe implements PipeTransform {

  public static pluck(value, key) {
    return get(value, key, null);
  }

  transform(value: any, paths?: string[]): string {
    if (!paths) {
      return value;
    }

    let returnValue;

    for (const path of paths) {
      if (value instanceof Array) {
        returnValue = value.map(val => PluckPipe.pluck(val, path)).filter(val => val);
      } else if (typeof value === 'object') {
        returnValue = PluckPipe.pluck(value, path);
      }
      if (returnValue) {
        break;
      }
    }
    return returnValue;
  }

}
